import {Inject, Injectable} from '@angular/core';
import {UserService} from '../../shared/services/user.service';
import {BehaviorSubject} from 'rxjs';
import {mainPath} from '../../app-routing.constants';
import {MenuItemLocal} from './menu-item.model';
import {DefaultDashboardService} from '../../shared/services/default-dashboard.service';
import {ApiList} from '../../API/api-list.enum';
import {CRUDString} from '../../../../projects/api/src/authentication/CRUDString.type';
import {RERORT_MENU_ID} from './menu';
import {ApplicationsApiService} from '../../../../projects/api/src/applications/applications-api.service';
import {ApplicationModel} from '../../../../projects/api/src/applications/application.model';


const gettext = (a) => a;
const angularMainPath = `/${mainPath}`;

@Injectable()
export class MenuService {
  public menu: BehaviorSubject<MenuItemLocal[]> = new BehaviorSubject<MenuItemLocal[]>([]);
  public _menu: any;
  public applicationName = '/app';
  public DataBaseStateName = 'db';
  public isCollapsed = new BehaviorSubject<boolean>(true);
  public isNotifyConfigPriv;
  public favoriteMenu: any;

  constructor(private defaultDashboardService: DefaultDashboardService,
              private userService: UserService,
              private applicationsApi: ApplicationsApiService,
              @Inject('CREATE_MENU') private CreateMenu: Function,
  ) {
    this.isNotifyConfigPriv = this.userService.privilegesObject['notifyconfig'] && this.userService.privilegesObject['notifyconfig'].includes('read');
    this.createMenu();
  }

  createMenu() {
    this.applicationsApi.getAllWithCache().subscribe({
      next: applications => this.buildMenu(applications),
      error: error => {
        console.error('Unable to load applications for menu', error);
        this.buildMenu([]);
      }
    });
  }

  private buildMenu(applications: ApplicationModel[]): void {
    this._menu = this.CreateMenu(this.userService.rawData.id, {applications})
      .map((val) => (val && val.template === RERORT_MENU_ID) ? this.getReportsMenu(val) : val);
    this.menu.next(this._menu);
  }

  getReportsMenu(val: {id: number; namespace: string; template?: string; path: string[]}) {
    if (this.userService.rawData.company.analytic) {
      return {
        id: 2,
        title: gettext('Reports and analytics'),
        iconCss: 'in in-chart-pie-filled',
        children: [
          {
            id: 21,
            pathArray: [...val.path, 'reports'],
            apiList: [ApiList.Report],
            title: gettext('Reports'),
            iconCss: 'in in-file-report',
            caption: 'CAPTION.REPORTS',
            visible: true
          },
          {
            id: 22,
            pathArray: [...val.path, 'analytics', 'dashboards'],
            apiList: [ApiList.Report],
            title: gettext('Analytics'),
            iconCss: 'in in-report-finance',
            caption: 'CAPTION.ANALITICSDASHBOARDS',
            visible: true
          },
        ]
      };
    } else {
      return {
        iconCss: 'in in-file-report',
        title: gettext('Reports'),
        id: 2,
        children: [
          {
            id: 21,
            pathArray: [...val.path, 'reports'],
            apiList: [ApiList.Report],
            title: gettext('Reports'),
            iconCss: 'in in-file-report',
            caption: 'Выгрузка отчетов за период',
            visible: true
          },
        ]
      };
    }
  }

  public clickOut() {
    const collapse = function(item) {
      if (item.children) {
        item.state = false;
      }
    };
    this.menu.forEach(item => {
      collapse(item);
    });
  }

  public checkAccess(item: string, minPrivilegy: CRUDString = 'read') {
    if (item !== null && item === 'calendartemplate') {
      return this.userService.privilegesObject[item] && this.userService.privilegesObject[item].includes(minPrivilegy);
    }
    if (item !== null && item === 'auditlog') {
      return this.userService.privilegesObject['audit_log'] && this.userService.privilegesObject['audit_log'].includes(minPrivilegy);
    }
    if (item !== null && item === 'paramstates') {
      return this.userService.privilegesObject[item] && this.userService.privilegesObject[item].includes(minPrivilegy);
    }
    if (item !== null && item === 'dwh') {
      return this.userService.privilegesObject['businessparam'] && this.userService.privilegesObject['businessparam'].includes(minPrivilegy);
    }
    if (item !== null && item === 'objecttype') {
      return this.userService.privilegesObject['objecttype'] && this.userService.privilegesObject['objecttype'].includes('update');
    }
    if (item !== null && item === 'deviceclassifier') {
      return this.userService.privilegesObject['deviceclassifier'] && this.userService.privilegesObject['deviceclassifier'].includes('update');
    }
    if (item !== null && item === 'notificationserver') {
      return this.userService.privilegesObject['notifyconfig'] && this.userService.privilegesObject['notifyconfig'].includes('read');
    }
    if (item !== null && item === 'chirpstackserver') {
      return this.userService.privilegesObject['notifyconfig'] && this.userService.privilegesObject['notifyconfig'].includes(minPrivilegy);
    }
    if (item !== null && item === 'pbxserver') {
      return this.userService.privilegesObject['asterisk_phone'] && this.userService.privilegesObject['asterisk_phone'].includes(minPrivilegy);
    }
    if (item !== null && (item === 'predefinedparam' || item === 'predefinedvalue')) {
      return this.userService.privilegesObject['predefined_value'] && this.userService.privilegesObject['predefined_value'].includes(minPrivilegy);
    }
/*    if (item !== null && item === 'nbiotserver') {
      return false; /!*this.userService.privilegesObject['devicegate'] && this.userService.privilegesObject['devicegate'].includes(minPrivilegy);*!/
    }*/
    /*if (item !== null && item === 'oauth2') {
      return this.userService.privilegesObject['oauth2provider'] && this.userService.privilegesObject['oauth2provider'].includes('update');
    }*/
    if (item !== null && item === 'controllersmanagement') {
      return this.userService.privilegesObject['controllerinventory'] && this.userService.privilegesObject['controllerinventory'].includes('update');
    }

    if (item !== null && item === 'drone') {
      return this.userService.privilegesObject['controllerinventory'] && this.userService.privilegesObject['controllerinventory'].includes('update');
    }

    if (item !== null && item === 'classifier') {
      return true;
    }


    if (item !== null && (item === 'branding' || item === 'contact')) {
      return this.userService.privilegesObject[item] && this.userService.privilegesObject[item].includes('update');
    }
    if (item !== null && (item === 'exwidget')) {
      return this.userService.privilegesObject[item] && this.userService.privilegesObject[item].includes('create');
    }
    if (item !== null && (item === 'extsystem')) {
      return this.userService.privilegesObject['incident'] && this.userService.privilegesObject['incident'].includes('update');
    }
    if (item !== null && (item === 'useractivitylog')) {
      return this.userService.privilegesObject['sessionlog'] && this.userService.privilegesObject['sessionlog'].includes('read');
    }
    if (item !== null && (item === 'sysuser' || item === 'usergroup' || item === 'sdirrole' || item === 'oauth2')) {
      return this.userService.privilegesObject['sdirrole'] && this.userService.privilegesObject['sdirrole'].includes(minPrivilegy);
    }

    return this.userService.privilegesObject[item] && this.userService.privilegesObject[item].includes(minPrivilegy);
  }

  public isActiveLink(location: string) {
    const hash = window.location.hash.split('?')[0];
    return hash.startsWith('#!' + location + '/') || hash === ('#!' + location);
  }


  public defaultDashboard() {
    return this.defaultDashboardService.id.getValue();
  }
}



